function isLocaleEN() {
  return process.env.VUE_APP_LOCALE === "en";
}

function isLocaleZH() {
  return process.env.VUE_APP_LOCALE === "zh";
}

export { isLocaleEN, isLocaleZH };
